
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.467.934a.667.667 0 01.534-.267h8c.21 0 .407.099.533.267l2 2.666a.667.667 0 01.133.4v9.334a2 2 0 01-2 2H2.334a2 2 0 01-2-2V4c0-.144.047-.284.133-.4l2-2.666zM3.334 2L1.667 4.223v9.11a.667.667 0 00.667.667h9.333a.667.667 0 00.667-.666V4.223L10.667 2H3.334z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.334 4c0-.368.298-.666.667-.666h12a.667.667 0 010 1.333H1A.667.667 0 01.334 4zM4.334 6c.368 0 .667.299.667.667a2 2 0 104 0 .667.667 0 011.333 0 3.333 3.333 0 01-6.667 0c0-.368.299-.667.667-.667z"}})])
          )
        }
      }
    